module.exports = __webpack_public_path__ + "img/air-img2.a530c6e1.png";